import { jumpLinkScrollTo } from '@/utils/helpers';
import { ChevronRight as ChevronRightIcon } from '@material-ui/icons';
import clsx from 'clsx';
import React, { memo, PropsWithChildren, useCallback, useEffect } from 'react';
import { MuiTypography } from '../material-ui';
import { JumplinksProps } from './Jumplinks.interface';
import useStyles from './Jumplinks.styles';

const Jumplinks = ({
  title,
  theme,
  elements = [],
  className: overrideClassName,
}: PropsWithChildren<JumplinksProps>) => {
  const classes = useStyles({});
  const jumplinksRef = React.useRef<any>(null);
  const containerClassName = clsx(classes.container, theme && `${theme}-theme`, overrideClassName);

  const fitLinkAndArrow = useCallback(({ container, links }: any) => {
    if (!links || links.length < 0) return;
    const { width: widthContainer }: any = container.getBoundingClientRect() || {};
    links.forEach((link: any) => {
      const { width: widthLink }: any = link.getBoundingClientRect() || {};
      if (parseInt(widthLink, 10) > parseInt(widthContainer, 10) + 20) {
        link.classList.add('wrapSpace');
      }
    });
  }, []);

  const scrollTo = useCallback((identifier: string) => {
    const anchor = document.querySelector(`#${identifier}`) as Element;
    anchor?.scrollIntoView({
      behavior: 'smooth',
    });
  }, []);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent, target: string) => {
      const isSpacebar = /^ $/i.test(event.key);
      const isEnter = /^enter$/i.test(event.key);

      if (!isSpacebar && !isEnter) {
        return;
      }

      event.preventDefault();
      scrollTo(target);
    },
    [scrollTo],
  );
  useEffect(() => {
    const jumpLinksEl = jumplinksRef?.current;
    if (!jumpLinksEl) return;

    const links = Array.from(jumpLinksEl?.querySelectorAll('h5'));
    if (!links) return;

    fitLinkAndArrow({ container: jumpLinksEl, links });
  });

  return (
    <div data-testid="qa-jumplinks-component" className={containerClassName} ref={jumplinksRef}>
      {title && (
        <MuiTypography className={classes.title} variant="overline" component="h3">
          {title}
        </MuiTypography>
      )}
      <nav data-testid="qa-jumplinks-component-nav">
        {elements.map((item) => {
          return (
            <MuiTypography
              className={clsx(classes.jumplink, 'gtm-jumplink')}
              variant="h5"
              key={item.href}
              tabIndex={0}
              onClick={(event: any) => {
                event.preventDefault();
                if (item?.href) {
                  jumpLinkScrollTo({ event, href: item.href });
                }
              }}
              onKeyDown={(ev: any) => item?.href && handleKeyDown(ev, item.href)}
              data-datalayer-link-type="link_to_scroll"
              data-datalayer-link
            >
              <span>{item.label}</span> <ChevronRightIcon className={classes.icon} />
            </MuiTypography>
          );
        })}
      </nav>
    </div>
  );
};

export default memo(Jumplinks);
